<template>
  <div v-if="features.bulkImports" class="imports-canvas-view">
    <eg-b-container>
      <section>
        <eg-b-row>
          <eg-b-col>
            <StartGradingContainer>
              <eg-b-row class="justify-content-center align-items-center">
                <eg-b-col cols="12">
                  <import-canvas-connect v-if="step === 1" social-name="Canvas">
                    <template #extra-instructions>
                      <ul>
                        <li>
                          {{ $t("imports.noChangesToCanvas") }}
                        </li>
                      </ul>
                    </template>
                    <template #continue-button>
                      <eg-b-button variant="info" @click="goToStep(2)">
                        Continue: Allow access to Canvas
                      </eg-b-button>
                    </template>
                  </import-canvas-connect>

                  <canvas-instruction v-else-if="step === 2" class="mt-3">
                    <template
                      #continue-button="{ canvasUrl, canvasToken, disabled }"
                    >
                      <eg-b-button
                        variant="info"
                        :disabled="disabled"
                        @click="importDetails(canvasUrl, canvasToken)"
                      >
                        Continue: Import Details
                      </eg-b-button>
                    </template>
                  </canvas-instruction>

                  <import-wizard-bulk
                    v-if="step === 3"
                    :service-id="ssoServiceData.serviceId"
                    :platform-key="ssoServiceData.serviceName"
                    platform="canvas"
                    title="Import from Canvas"
                  />
                </eg-b-col>
              </eg-b-row>
            </StartGradingContainer>
          </eg-b-col>
        </eg-b-row>
      </section>
    </eg-b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUser } from "@/api";
import importApi from "@/api/requests/import";
import ImportCanvasConnect from "@/components/imports/imports_connect.vue";
import CanvasInstruction from "@/components/imports/canvas/canvas_instruction.vue";
import StartGradingContainer from "@/components/start-grading/start_grading_container.vue";
import { mergeUserData } from "@/utils/userUtils";
import { SSO_SERVICE } from "@/constants";
import ImportWizardBulk from "@/components/imports/imports_wizard_bulk.vue";

const serviceName = "canvas";

export default {
  components: {
    ImportWizardBulk,
    ImportCanvasConnect,
    CanvasInstruction,
    StartGradingContainer,
  },

  provide() {
    return {
      serviceAccount: this.serviceAccount,
      serviceName,
    };
  },

  data() {
    return {
      step: 1,
      serviceAccount: {
        id: null,
      },
      ssoServiceData: SSO_SERVICE,
    };
  },

  computed: {
    ...mapGetters("config", ["features"]),
  },
  beforeMount() {
    if (!this.features.bulkImports) {
      this.$router.replace({ path: "/" });
    }
  },

  async created() {
    if (this.features.bulkImports) {
      this.serviceAccount.id = "sso";
      this.goToStep(3);
    }
  },

  methods: {
    goToStep(number) {
      this.step = number;
    },

    async importDetails(canvasUrl, canvasToken) {
      try {
        const { data } = await importApi[serviceName].createCredentials(
          canvasUrl,
          canvasToken
        );
        this.serviceAccount.id = data.id;
        const { data: userData } = await getUser("me");
        const newUserData = mergeUserData(this, userData);
        await this.$store.dispatch("setUser", newUserData);

        if (userData.canvasPersonalCredentials || userData.cid) {
          this.goToStep(3);
        } else {
          this.$showToastError("Please check URL and Token, then try again.");
        }
      } catch (error) {
        this.$showToastError("Please check URL and Token, then try again.");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.imports-canvas-view {
  min-height: calc(100vh - var(--main-header-height));
  background-color: var(--grey-100);
}
</style>
